import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: white;
  }
`;

export const PageWrapper = styled.div`
	padding: 20px 74px 0px 74px;
`;

export const ProjectName = styled.div`
	margin-top: 29px;
	margin-bottom: 28px;
	font-size: 28px;
	font-weight: 500;
	line-height: 28px;
	text-align: left;
`;

export const ProjectOwnerName = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: end;
	padding-bottom: 28px;
	font-size: 11px;
	font-weight: 500;
	line-height: 10.89px;
	text-align: left;

	span:first-child {
		line-height: 10.89px;
		text-align: left;
	}

	span:last-child {
		color: #343a40;
	}
`;

export const ProjectHeader = styled.div`
	display: flex;
	justify-content: space-between;

	.left-group {
		display: flex;
		align-items: center;

		.w-full p-dropdown p-component p-inputwrapper p-dropdown-clearable p-inputwrapper-filled {
			border: none !important;
		}

		.p-dropdown-trigger{
			border: none !important;
		}

		.p-dropdown-label p-inputtext p-dropdown-label-empty {
			display:none !important;
		}

		.p-dropdown-label {
			display:none !important;
		}

		.p-icon p-dropdown-clear-icon p-clickable {
			display:none !important;
		}

		.p-dropdown-clear-icon {
			display:none !important;
		}
	}
`;

export const BreadCrumb = styled.span`
	cursor: pointer;
`;

export const DashboardsTab = styled.ul`
	font-size: 11px;
	margin-top: 49px;
	font-weight: 700;

	li a {
		padding: 14px;
		cursor: pointer;
	}

	.nav-item a {
		color: #6c757d;

		i {
			padding-right: 5px;
			font-size: 14px;
		}
	}

	.nav-item a:hover {
		border: none;
		border-bottom: 1px solid #46389e;
	}

	.nav-item .active {
		color: #5341c6;
		border: none;
		border-bottom: 1px solid #46389e;
		background-color: rgba(104, 96, 228, 0.04);
		margin-top: 2px;
	}

	.nav-item .tab-label {
		font-weight: 500;
	}
`;

export const StackedBarChartDiv = styled.div`
	.stacked-bar-chart {
		svg {
			text {
				fill: #212529;
				font-weight: 400;
				font-size: 0.65rem;
			}
		}
	}
`;